import React, { useMemo } from 'react';
import { injectIntl } from 'react-intl-next';
import { type TemplatesPanelContainerProps } from './types';
import { useTemplatesPanelControls } from './useTemplatesPanelControls';
import { type Template } from '../template/types';
import { TemplatesPanelHoverPreview } from '../../ui/templates-panel-hover-preview';
import TemplatesSidebar from '../../ui/project-pages-improvement/templates-sidebar';
import messages from './messages';
import { usePreloadPreviews } from '../template';

export const TemplatesPanelContainer = ({
	accessRequestCapability,
	areTemplatesEnabled,
	blueprints,
	contentId,
	containerRef,
	isConfluenceAutoProvisioned,
	intl,
	hasAccessToConfluence,
	origin,
	confluenceLicenseStatus,
	showError,
	spaceKey,
	projectId,
	projectType,
	isProjectPagesSporkRebrandingEnabled,
}: TemplatesPanelContainerProps) => {
	const { getTemplates, props, hoverPreviewProps } = useTemplatesPanelControls({
		accessRequestCapability,
		areTemplatesEnabled,
		blueprints,
		contentId,
		intl,
		hasAccessToConfluence,
		origin,
		spaceKey,
		showError,
		projectId,
		projectType,
	});

	const templates = useMemo<Template[]>(
		() =>
			getTemplates({
				intl,
				isConfluenceAutoProvisioned,
				isProjectPagesSporkRebrandingEnabled,
				confluenceLicenseStatus,
			}),
		[
			intl,
			isConfluenceAutoProvisioned,
			isProjectPagesSporkRebrandingEnabled,
			confluenceLicenseStatus,
			getTemplates,
		],
	);
	usePreloadPreviews(templates, hasAccessToConfluence);

	return hasAccessToConfluence ? (
		<TemplatesPanelHoverPreview
			containerRef={containerRef}
			templates={templates}
			hoverPreviewProps={hoverPreviewProps}
			origin={origin}
			{...props}
		/>
	) : (
		<TemplatesSidebar
			templates={templates}
			{...props}
			title={messages.noConfluenceLicenseTitle}
			subtitle={messages.noConfluenceLicenseSubTitle}
		/>
	);
};

export default injectIntl(TemplatesPanelContainer);
